export const MOBILE_BANNER_KEY = 'mobile-banner-dismissed';
export const MOBILE_MAX_WIDTH = 640;
export const SMALL_SCREEN_MAX_WIDTH = 1440;
